class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.content.addEventListener('mouseenter', this.onMenuEnter.bind(this));
    this.content.addEventListener('mouseleave', this.onMenuLeave.bind(this));

    this.closeTimeout = null;
  }

  onMouseEnter() {
    this.open();
  }

  onMouseLeave() {
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 200);
  }

  onMenuEnter() {
    clearTimeout(this.closeTimeout);
  }

  onMenuLeave() {
    this.onMouseLeave();
  }

  onToggle() {
    console.log('toggle');
    if (!this.animations) this.animations = this.content.getAnimations();
    console.log(this.animations);
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.trigger = this.querySelector('.header__menu-item');
    this.content = this.querySelector('.header__submenu');
    this.closeTimeout = null;

    if (!this.trigger || !this.content) return;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('focusin', this.onFocusIn.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  onMouseEnter() {
    this.open();
  }

  onMouseLeave() {
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 200);
  }

  onFocusIn() {
    this.open();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.close();
    this.trigger.focus();
  }

  open() {
    clearTimeout(this.closeTimeout);
    this.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', true);

    if (!this.header) return;
    this.header.preventHide = true;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  close() {
    clearTimeout(this.closeTimeout);
    this.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', false);

    if (!this.header) return;
    this.header.preventHide = false;
  }
}

customElements.define('header-menu', HeaderMenu);
